/** Types for the connector catalog system. */

export interface CatalogConfigField {
  name: string;
  label: string;
  type: 'string' | 'integer' | 'boolean' | 'password' | 'select' | 'textarea';
  required: boolean;
  default?: any;
  description: string;
  options?: string[];
  placeholder?: string;
  depends_on?: Record<string, string[]>;
}

export interface CatalogConnector {
  connector_id: string;
  display_name: string;
  short_description: string;
  direction: 'source' | 'destination' | 'both';
  category: string;
  icon: string;
  dlt_source_type: string;
  dlt_source_name?: string;
  logo_url?: string;
  tags: string[];
  is_popular: boolean;
  tier: number;
  /** Whether the dlt source backing this connector is installed and usable. */
  installed?: boolean;
  config_fields: CatalogConfigField[];
}

export interface CatalogCategory {
  name: string;
  count: number;
}

export interface CatalogResponse {
  connectors: CatalogConnector[];
  total: number;
  categories: CatalogCategory[];
}

/** Icon mapping: catalog icon name -> Material-UI icon identifier */
export const CATEGORY_ICONS: Record<string, string> = {
  'Databases': 'Storage',
  'Cloud Warehouses': 'CloudQueue',
  'Files & Storage': 'FolderOpen',
  'CRM & Sales': 'BusinessCenter',
  'Payments & Commerce': 'Payment',
  'Productivity & PM': 'Assignment',
  'Marketing & Analytics': 'Analytics',
  'Dev Tools': 'Code',
  'Support': 'SupportAgent',
  'Communication': 'Chat',
  'Custom': 'Api',
};

/** Brand colors for connector cards (keyed by connector_id) */
export const CONNECTOR_COLORS: Record<string, string> = {
  postgresql: '#336791',
  mysql: '#4479A1',
  mssql: '#CC2927',
  snowflake: '#29B5E8',
  bigquery: '#4285F4',
  s3: '#FF9900',
  google_sheets: '#0F9D58',
  salesforce: '#00A1E0',
  hubspot: '#FF7A59',
  stripe: '#635BFF',
  shopify: '#96BF48',
  gcs: '#4285F4',
  azure_blob: '#0089D6',
  mongodb: '#47A248',
  jira: '#0052CC',
  notion: '#000000',
  airtable: '#FCBF49',
  redshift: '#8C4FFF',
  rest_api: '#6366F1',
  sftp: '#607D8B',
  zendesk: '#03363D',
  slack: '#4A154B',
  github: '#24292E',
  google_analytics: '#E37400',
  facebook_ads: '#1877F2',
  google_ads: '#4285F4',
  oracle: '#F80000',
  databricks: '#FF3621',
  pipedrive: '#017737',
  asana: '#F06A6A',
  box: '#0061D5',
};
